module.exports = __webpack_public_path__ + "c04319ca24fdf3491ce6e60ca3a0f2a0.svg";